// @mui
import { styled } from '@mui/material/styles';
import { Card, Container, Typography, Stack } from '@mui/material';
import { Navigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import { useEffect, useState } from 'react';

// GRAPHQL
import { useQuery } from '@apollo/client';
import { ProfileGQLFunction } from '../graphql/SEVER_PROFILE';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Page from '../components/Page';
import Logo from '../components/Logo';
import LanguageSelector from '../layouts/dashboard/LanguageSelector';
// sections
import { LoginForm } from '../sections/login';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7)
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

import { useTranslation } from 'react-i18next';
// ----------------------------------------------------------------------

export default function Login() {
  const { t } = useTranslation();
  const { data: serverProfileData } = useQuery(ProfileGQLFunction.GET_SERVER_PROFILEPO);
  const cn = serverProfileData?.getServerProfile?.cn || '';

  const mdUp = useResponsive('up', 'md');
  const authed = secureLocalStorage.getItem('token');

  if (authed) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <Page title={t('login.button')}>
      <RootStyle>
        <HeaderStyle>
          <Logo />
          <LanguageSelector />
        </HeaderStyle>

        {mdUp && (
          <SectionStyle>

            <img src="/static/illustrations/illustration_login.png" alt="login" />
          </SectionStyle>
        )}

        <Container maxWidth="sm">
          <ContentStyle>
            <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
              <Typography variant="h4">
                {t('login.title')}
              </Typography>
              {cn && (
                <Typography variant="h4" sx={{ color: 'text.secondary', ml: 1 }}>
                  - {cn}
                </Typography>
              )}
            </Stack>

            <LoginForm />
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
